import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '@/components/layout/PageLayout';
import { ROUTE_DEFINITIONS } from '@/routes';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { IconScout } from '@/components/ui/images/IconScout';
import Table from '@/components/ui/tables/Table';
import { useCompanyList } from '@/hooks/company/useCompanyList';
import { PermissionGuard } from '@/components/layout';


export const CompanyList: React.FC = () => {
  const {
    rows,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    columns,
    actions,
    onSearch,
    onSortChange,
    loading,
  } = useCompanyList();

  return (
    <PageLayout>
      <div className="flex flex-col gap-6" data-testid="company-list-page">
        <div>
          <PermissionGuard action="create">
            <Link to={ROUTE_DEFINITIONS.EMPRESAS_CREAR.path}>
              <PrimaryButton iconLeft={<IconScout name="plus" />}>
                Nueva empresa
              </PrimaryButton>
            </Link>
          </PermissionGuard>
        </div>

        {/* Tabla */}
        <Table
          columns={columns}
          data={rows}
          totalRows={total}
          searchable
          onSearch={onSearch}
          serverSideSort
          onSortChange={onSortChange}
          columnMaxWidth={150}
          initialSort={{ key: 'name', direction: 'asc' }}
          actions={actions}
          pagination={{
            page,
            pageSize,
            total: total,
            onChange: setPage,
            onPageSizeChange: setPageSize,
          }}
          data-testid="company-table"
          isLoading={loading}
        />
      </div>
    </PageLayout>
  );
};

export default CompanyList;
